'use client'

import React, { useState, useEffect, act } from 'react';
import { Link, useNavigate } from 'react-router-dom';            
import { useToaster } from '../context/ToasterContext';
import Spinner from "../components/Spinner";
import Button from '../components/Button';
import Table from '../components/Table';
import ConfirmationModal from '../components/ConfirmationModal';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPolicies } from '../redux/globalDataSlice';
import api from '../api/axios';

export default function OptinOptoutPolicies() {
  const { toaster } = useToaster();
  const dispatch = useDispatch();
  const navigate = useNavigate();                               

  const [loading, setLoading] = useState(true);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const { policies, dataLoading } = useSelector((state) => state.globalData);
  const activeAccountId = useSelector((s) => s.globalData.activeAccountId); 

  useEffect(() => {
    setLoading(dataLoading);
  }, [dataLoading]);



  const initDeletePolicy = (itemData) => {
    setShowConfirmationModal(true);
    setSelectedItem(itemData);
  }

  const deleteOptinOptoutPolicy = async () => {
    try {
      await api.delete(`${process.env.REACT_APP_BASE_API_URL}/mvapi/utils/optout/account/${activeAccountId}/${selectedItem.id}`);
      toaster.success('Opt-in opt-out policy deleted successfully!');

      if (activeAccountId) {
        dispatch(fetchPolicies());
      }

      setShowConfirmationModal(false);
    } catch (error) {
      console.error('Error:', error);
      toaster.error('Something went wrong. Please try again.');
    }
  }

  return (
    <>
      {loading && <Spinner />}

      {!loading &&
        <>
          <div className="px-4 sm:px-6 lg:px-8">
            <div className="sm:flex sm:items-center">
              <div className="sm:flex-auto">
                <h2 className="text-2xl/7 font-bold text-gray-900 dark:text-gray-100 sm:truncate sm:text-3xl sm:tracking-tight">Opt-In & Opt-Out Policies</h2>
                <p className="mt-1 text-sm text-gray-700 dark:text-gray-300">
                  Manage all your Opt-In & Opt-Out policies here
                </p>
              </div>
              <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
                <Button
                type="button"
                onClick={() => navigate('/add-optin-optout-policy')}
                variant="primary"
                className="">
                  Create new policy
                </Button>
              </div>
            </div>
            <div className="mt-8">
              <Table
                data={policies}
                onRowClick={(policy) => navigate(`/edit-optin-optout-policy/${policy.id}`)}
                columns={[
                  { key: 'name', title: 'Policy name' },
                  {
                    key: 'actions',
                    title: 'Actions',
                    align: 'right',
                    render: (policy) => (
                      <div className="space-x-2">
                          { /* <a href={`/edit-optin-optout-policy/${policy.id}`} className="text-emerald-600 dark:text-emerald-400 hover:text-emerald-900 dark:hover:text-emerald-100 mr-5">Edit</a> */ }
                        <Link
                          to={`/edit-optin-optout-policy/${policy.id}`}
                          className="text-emerald-600 dark:text-emerald-400 hover:text-emerald-900 dark:hover:text-emerald-100 mr-5"
                          >
                          Edit
                          </Link>
                        <button type="button" onClick={() => initDeletePolicy(policy)} className="text-red-600 dark:text-red-400 hover:text-red-900 dark:hover:text-red-100">Delete</button>
                      </div>
                    )
                  }
                ]}
                emptyState={{
                  title: 'No Opt-In & Opt-Out policies found',
                  description: 'Get started by creating a new policy.'
                }}
              />
            </div>
          </div>
        </>
      }

      <ConfirmationModal
        open={showConfirmationModal}
        title="Delete policy"
        description="Are you sure you want to delete? This action cannot be undone."
        confirmText="Yes"
        cancelText="No"
        onConfirm={deleteOptinOptoutPolicy}
        onCancel={() => setShowConfirmationModal(false)}
      />
    </>
  )
}